import Vue from 'vue';
import { mapMutations, mapState } from 'vuex';
export default Vue.extend({
    data() {
        return {
            currentScreenReaderAlert: '',
            previousKeyboardingSegment: ''
        };
    },
    computed: Object.assign({}, mapState('accessibility', {
        currentKeyboardingSegment: (state) => state.currentKeyboardingSegment
    })),
    methods: Object.assign(Object.assign({}, mapMutations('accessibility', [
        'setCurrentKeyboardingSegment',
        'setTotalKeyboardingSegment'
    ])), { getTouchHoldBasedInstructions(rootInstructions) {
            let instructions = rootInstructions;
            const leftHandPositionEl = document.getElementById('LeftHandPosition');
            const rightHandPositionEl = document.getElementById('RightHandPosition');
            if (leftHandPositionEl && leftHandPositionEl.getAttribute('aria-label')) {
                instructions = `Hold the f key with your left index finger. Then ${instructions.toLowerCase()}`;
            }
            if (rightHandPositionEl) {
                instructions = `Hold the j key with your right index finger. Then ${instructions.toLowerCase()}`;
            }
            return instructions;
        },
        clearKeyboardingSegmentAlert() {
            const keyboardingSegmentAlertEl = document.getElementById('keyboardingSegmentAlert');
            if (keyboardingSegmentAlertEl)
                keyboardingSegmentAlertEl.innerText = '';
        },
        rerenderKeyboardingSegmentAlert(message, timeoutInterval) {
            const keyboardingSegmentAlertEl = document.getElementById('keyboardingSegmentAlert');
            if (keyboardingSegmentAlertEl) {
                const rerenderMsg = message || keyboardingSegmentAlertEl.innerText;
                keyboardingSegmentAlertEl.innerText = '';
                setTimeout(() => {
                    keyboardingSegmentAlertEl.innerText = rerenderMsg;
                }, timeoutInterval || 500);
            }
        },
        rerenderScreenReaderAlert(message, timeoutInterval) {
            const screenReaderAlertEl = document.getElementById('screenReaderAlert');
            if (screenReaderAlertEl) {
                const rerenderMsg = message || screenReaderAlertEl.innerText;
                this.currentScreenReaderAlert = rerenderMsg;
                screenReaderAlertEl.innerText = '';
                setTimeout(() => {
                    screenReaderAlertEl.innerText = rerenderMsg;
                }, timeoutInterval || 500);
            }
        },
        setScreenReaderAlert(message) {
            this.currentScreenReaderAlert = message;
            const screenReaderAlertEl = document.getElementById('screenReaderAlert');
            if (screenReaderAlertEl) {
                screenReaderAlertEl.innerText = message;
            }
        },
        setKeyboardingSegmentAlert(attempt, isEndOfSentence, options = {}) {
            const keyboardingSegmentAlertEl = document.getElementById('keyboardingSegmentAlert');
            if (!keyboardingSegmentAlertEl)
                return;
            const sanitizedChar = this._sanitizeChar(attempt.character);
            this.setCurrentKeyboardingSegment(this.currentKeyboardingSegment.concat(sanitizedChar));
            let isSentenceSegment = false;
            /*
              We want to alert the screen reader of a sentence if:
              - One of the ['.', '?', '!'] characters are entered
              - Is not an ordered list item marker. Example: 1.
            */
            if (['.', '?', '!'].includes(sanitizedChar) && !this._isOrderedListItemMarker()) {
                isSentenceSegment = true;
                const message = options.alertMessageOverride ||
                    `You have typed the sentence - ${this._getSentenceSegment(sanitizedChar)}`;
                if (!options.skipAnnouncement) {
                    if (options.rerenderAlert) {
                        this.rerenderKeyboardingSegmentAlert(message);
                    }
                    else {
                        keyboardingSegmentAlertEl.innerText = message;
                    }
                }
            }
            /*
              We want to alert the screen reader of a segment if:
              - Current segment is complete
              - *And if the current segment is not equal to the sentence that was just announced
            */
            if (isEndOfSentence) {
                if (!isSentenceSegment ||
                    !(this.currentKeyboardingSegment === this._getSentenceSegment(sanitizedChar))) {
                    const isSegmentSentence = !this.currentKeyboardingSegment.match(/\.|\?|\!/g) ||
                        this.currentKeyboardingSegment[0].toUpperCase() === this.currentKeyboardingSegment[0];
                    const message = options.alertMessageOverride ||
                        `You have typed the segment - ${isSegmentSentence ? '' : `${this.previousKeyboardingSegment} `}${this.currentKeyboardingSegment}`;
                    if (!options.skipAnnouncement) {
                        if (options.rerenderAlert) {
                            this.rerenderKeyboardingSegmentAlert(message);
                        }
                        else {
                            keyboardingSegmentAlertEl.innerText = message;
                        }
                    }
                }
                this.previousKeyboardingSegment = `${this.currentKeyboardingSegment}`;
                this.setCurrentKeyboardingSegment('');
                this.setCurrentKeyboardingSegment(this.currentKeyboardingSegment);
            }
        },
        _getWordSegment(character, context) {
            const { isEndOfSentence, isEndOfWord } = context;
            const spaceKeyEntered = character === ' ';
            const lastIndexOfSpace = this.currentKeyboardingSegment.lastIndexOf(' ');
            const secondToLastIndexOfSpace = this.currentKeyboardingSegment.lastIndexOf(' ', lastIndexOfSpace - 1);
            if (isEndOfSentence) {
                return this._cleanWord(`${this.currentKeyboardingSegment.slice(lastIndexOfSpace, this.currentKeyboardingSegment.length - 1)}`);
            }
            if (isEndOfWord) {
                return this._cleanWord(`${this.currentKeyboardingSegment.slice(lastIndexOfSpace === -1 ? 0 : lastIndexOfSpace, this.currentKeyboardingSegment.length)}`);
            }
            return this._cleanWord(`${this.currentKeyboardingSegment.slice(secondToLastIndexOfSpace === -1 ? 0 : secondToLastIndexOfSpace, spaceKeyEntered ? lastIndexOfSpace - 1 : lastIndexOfSpace)}`);
        },
        _getSentenceSegment(character) {
            const sentences = this.currentKeyboardingSegment.split(/\.|\?|\!/);
            return `${sentences[sentences.length - 2].trim()}${character}`;
        },
        _cleanWord(word) {
            return word.replace(/\.|\"/g, '');
        },
        _isOrderedListItemMarker() {
            return !!this.currentKeyboardingSegment.match(/^\d+\.\s*/g);
        },
        _sanitizeChar(char) {
            return char.replace(/enter/g, '');
        } })
});
